import { ModalOpenButton } from "@msys/ui";
import { Add as AddIcon, Edit as EditIcon } from "@mui/icons-material";
import { Box, Button, IconButton } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { TemplateTypesSearchModal } from "./TemplateTypesSearchModal.js";
import { TemplateTypesSearchModal_TemplateTypeFragment } from "./TemplateTypesSearchModal.generated.js";
import { TemplateTypeLabeledValue } from "./TemplateTypeLabeledValue.js";

interface Props {
  templateTypeId: string | null;
  label?: string;
  selectButtonLabel?: string;
  leftIcon?: React.ReactNode;
  rightButton?: React.ReactNode;
  onChange: (
    templateType: TemplateTypesSearchModal_TemplateTypeFragment
  ) => Promise<void> | void;
  onClear?: () => Promise<void> | void;
  required?: boolean;
  disabled?: boolean;
  canEdit?: boolean;
}

export const TemplateTypeInput = ({
  templateTypeId,
  label,
  selectButtonLabel,
  leftIcon,
  rightButton,
  required = false,
  disabled = false,
  canEdit = true,
  onChange,
  onClear,
}: Props) => {
  const { t } = useTranslate(["TemplateTypes", "Global"]);
  if (!canEdit) {
    return (
      <TemplateTypeLabeledValue
        templateTypeId={templateTypeId}
        label={label}
        leftIcon={leftIcon}
      />
    );
  }
  return !templateTypeId ? (
    <Box display="flex">
      <ModalOpenButton
        Modal={TemplateTypesSearchModal}
        modalProps={{
          handleSelectTemplateType: async (templateType, handleClose) => {
            await onChange(templateType);
            handleClose();
          },
        }}
        disabled={disabled}
      >
        <Button
          size="small"
          color="secondary"
          variant="text"
          startIcon={<AddIcon />}
          disabled={disabled}
          sx={{ textWrap: "nowrap" }}
        >
          {selectButtonLabel ?? t("Add template type", { ns: "TemplateTypes" })}
        </Button>
      </ModalOpenButton>
    </Box>
  ) : (
    <TemplateTypeLabeledValue
      templateTypeId={templateTypeId}
      label={label}
      leftIcon={leftIcon}
      required={required}
      rightButton={
        rightButton ?? (
          <ModalOpenButton
            Modal={TemplateTypesSearchModal}
            modalProps={{
              handleSelectTemplateType: async (templateType, handleClose) => {
                await onChange(templateType);
                handleClose();
              },
              handleClearTemplateType: onClear
                ? async handleClose => {
                    await onClear();
                    handleClose();
                  }
                : undefined,
            }}
            disabled={disabled}
          >
            <IconButton size="small" color="primary" disabled={disabled}>
              <EditIcon />
            </IconButton>
          </ModalOpenButton>
        )
      }
    />
  );
};
